import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import { connectRouter } from 'connected-react-router';
import { toastsReducer as toasts } from 'react-toastify-redux';

import sharedReducers from './duck';
import projectsReducers from '../projects/duck';
import modelsReducers from '../models/duck';
import brainHealthReducers from '../brainHealth/duck';
import healthcareReducers from '../healthcareFacility/duck';
import citiesCommunitiesReducers from '../citiesCommunities/duck';
import higherEdReducers from '../higherEd/duck';

const reducers = history =>
  combineReducers({
    form,
    router: connectRouter(history),
    shared: sharedReducers,
    projects: projectsReducers,
    models: modelsReducers,
    brainHealth: brainHealthReducers,
    healthcare: healthcareReducers,
    citiesCommunities: citiesCommunitiesReducers,
    higherEd: higherEdReducers,
    toasts,
  });

export default reducers;
